import React, { Component } from "react";
import Api from "../Api";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import $ from "jquery";


export default class MediaItemPreview extends Component {

    onChangePageAnimation(e, url) {
        $('html,body').scrollTop(0);
    }

    componentDidMount() {
        if ($ && $.fn) {
            $.fn.equalizeHeight = function (includeMargins) {
                let maxHeight = 0,
                    itemHeight;

                this.css('height', '');

                for (let i = 0; i < this.length; i++) {
                    if (includeMargins) {
                        itemHeight = $(this[i]).outerHeight();
                    } else {
                        itemHeight = $(this[i]).height();
                    }
                    if (maxHeight < itemHeight) {
                        maxHeight = itemHeight;
                    }
                }

                return this.height(maxHeight);
            };

            if (window.matchMedia("(min-width: 768px)").matches) {
                $('.media-item').equalizeHeight(false);
            }
        }
    }

    render() {
        const item = this.props.item;

        let isExternal = false;
        let link = `/media/${item.alias}`;

        if (item.sourceUrl) {
            link = item.sourceUrl;
            const host = typeof window !== 'undefined' ? window.location.host : '';
            isExternal = item.sourceUrl && !new RegExp(host).test(link);

            if (!isExternal) {
                link = link.replace( /^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+/, '' );
            }
        }

        return <div className="col-xs-12 col-sm-6 media-item" ref={item.id}>
            <Link className="media-item__wrapper relative imgfill" to={link}
                  target={isExternal ? '_blank' : ''}
                  onClick={(e) => this.onChangePageAnimation(e)}
                  style={{ backgroundImage: 'url(' + Api.getImage(item.background) + ')' }}>
                <div className="media-item__content">
                    <img data-src={Api.getImage(item.logo)} alt="" className="media-item__logo lazyload"/>
                    <h3 className="media-item__title u-bold">{item.title}</h3>
                    <div className="media-item__description"
                         dangerouslySetInnerHTML={{ __html: item.description }}></div>
                </div>
            </Link>
        </div>
    }
}

MediaItemPreview.propTypes = {
    item: PropTypes.any.isRequired,
    left: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/js/components/MediaItemPreview.js